import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
export default class DestaquesNoticias3 {
    constructor() {
        this.sections = document.querySelectorAll('.component-destaques_noticias3');
        this.ready();
    }

    ready() {

        this.sections.forEach(section => {
            const slider = section.querySelector('.swiper')
            const swiper = new Swiper(slider, {
                modules: [Navigation, Pagination],
                grabCursor: true,
                allowTouchMove: true,
                loop: false,
                navigation: {
                    nextEl: section.querySelector('.slider-button-next'),
                    prevEl: section.querySelector('.slider-button-prev'),
                },
                pagination: {
                    el: section.querySelector('.swiper-pagination-nav'),
                    type: 'fraction',
                    renderFraction: (currentClass, totalClass) => {
                        return `
                            <span class="${currentClass}"></span> /
                            <span class="${totalClass}"></span>
                        `;
                    },
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.3,
                        spaceBetween: 24,
                        slidesOffsetBefore: 24,
                        slidesOffsetAfter: 24,
                    },
                    1270: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                    }
                },
                on: {
                    init: function () {
                        DestaquesNoticias3.formatPagination(section);
                    },
                    slideChange: function () {
                        DestaquesNoticias3.formatPagination(section);
                    },
                }
            });
        })

    }

    static formatPagination(section) {
        const currentElement = section.querySelector('.swiper-pagination-nav .swiper-pagination-current');
        const totalElement = section.querySelector('.swiper-pagination-nav .swiper-pagination-total');

        if (currentElement) {
            currentElement.textContent = currentElement.textContent.padStart(2, '0');
        }
        if (totalElement) {
            totalElement.textContent = totalElement.textContent.padStart(2, '0');
        }
    }

}

if (document.querySelector('.component-destaques_noticias3')) {
    new DestaquesNoticias3();
}